export default {
    baseUrl: process.env.NODE_ENV === "production" ?
        location.origin : "http://localhost/dimatique/dev/public",
};